import React, { Component } from "react";
import { Link } from "react-router-dom";
import { debounce } from "lodash";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as RegionsActions,
  Selectors as RegionsSelectors
} from "store/ducks/regions";

import { Access } from "common";
import { Form, Loading } from "components";

class CampaignForm extends Component {
  state = {
    data: this.props.data
  };

  constructor(props) {
    super(props);

    const { getRegionPlacesRequest } = props;

    this.handleSearchPlaces = debounce(getRegionPlacesRequest, 300);
  }

  componentDidMount() {
    const { getRegionPlacesRequest } = this.props;

    getRegionPlacesRequest();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = e => {
    const { value, name } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleFindPlaces = value => {
    this.handleSearchPlaces(value);
  };

  handleSelectPlaces = places => {
    const { data } = this.state;
    this.setState({
      data: { ...data, places }
    });
  };

  render() {
    const { data } = this.state;
    const { saving, places, onSubmit } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Região</h3>

        <Form.Field>
          <Form.Label>Região</Form.Label>
          <Form.Input
            name="name"
            placeholder="região"
            value={data.name}
            onChange={this.handleChangeInput}
          />
        </Form.Field>

        <Form.Field className="field-select">
          <Form.Label>Lojas</Form.Label>
          <Form.Select
            isMulti
            placeholder="Lojas"
            noOptionsMessage={() => "Procurar Lojas"}
            options={places.data}
            onInputChange={this.handleFindPlaces}
            onChange={this.handleSelectPlaces}
            value={data.places}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/regions" className="button-cancel">
            Cancelar
          </Link>

          {Access.hasPermissions("edit-regions") && (
            <Form.Button
              className="button-save"
              onClick={onSubmit}
              disabled={saving}
            >
              {saving ? (
                <Loading type="btn" size="small" text="Salvando..." />
              ) : (
                "Salvar"
              )}
            </Form.Button>
          )}
        </div>
      </Form>
    );
  }
}

const mapState = state => ({
  places: {
    ...state.regions.places,
    data: RegionsSelectors.places(state.regions.places.data)
  }
});

const mapActions = dispatch => bindActionCreators(RegionsActions, dispatch);

export default connect(mapState, mapActions)(CampaignForm);
